import { render } from "./mirrorReveal.vue?vue&type=template&id=2e8287f8&scoped=true"
import script from "./mirrorReveal.vue?vue&type=script&lang=js"
export * from "./mirrorReveal.vue?vue&type=script&lang=js"

import "./mirrorReveal.vue?vue&type=style&index=0&id=2e8287f8&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8287f8"]])

export default __exports__